import { render } from "./DDropdownItem.vue?vue&type=template&id=bc7e8a5e"
import script from "./DDropdownItem.vue?vue&type=script&lang=js"
export * from "./DDropdownItem.vue?vue&type=script&lang=js"

import "./DDropdownItem.vue?vue&type=style&index=0&id=bc7e8a5e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__